import { createAction } from '@reduxjs/toolkit';

export const requestCreateSystemUser = createAction('request/createSystemUser');
export const requestViewSystemUser = createAction('request/viewSystemUser');
export const requestUpdateSystemUser = createAction('request/updateSystemUser');
export const requestInitiatePasswordReset = createAction('request/initiatePasswordReset');
export const requestResetPassword = createAction('request/resetPassword');
export const requestDeleteAccount = createAction('request/deleteAccount');
